// export const API_URL = "API_URL_GOES_HERE";
export const Server_URL = "http://localhost:3022";
// export const Server_URL = "https://server.hlzoptics.com";
// export const Server_URLx = "https://server.hlzoptics.com";